module.exports = __webpack_public_path__ + "img/avatar_ireliacarriesu.39599d4c.png";